import React from 'react';
import dayjs from 'dayjs';
import { Group, NativeSelect, Text } from '@mantine/core';
import { upperFirst } from '@mantine/hooks';
import { getMonthsNames } from '../../../utils/get-months-names/get-months-names.js';
import { getYearsRange } from '../../../utils/get-years-range/get-years-range.js';
import useStyles from './CalendarLabel.styles.js';
function CalendarLabel(_ref) {
  var locale = _ref.locale,
    classNames = _ref.classNames,
    styles = _ref.styles,
    withSelect = _ref.withSelect,
    yearsRange = _ref.yearsRange,
    value = _ref.value,
    labelFormat = _ref.labelFormat,
    _onChange = _ref.onChange,
    size = _ref.size,
    __staticSelector = _ref.__staticSelector,
    monthLabel = _ref.monthLabel,
    yearLabel = _ref.yearLabel,
    preventFocus = _ref.preventFocus;
  var selectSize = size === "lg" || size === "xl" ? "md" : "xs";
  var _useStyles = useStyles(null, {
      classNames: classNames,
      styles: styles,
      name: __staticSelector
    }),
    classes = _useStyles.classes;
  return withSelect ? /* @__PURE__ */React.createElement(Group, {
    spacing: 5,
    noWrap: true,
    className: classes.calendarSelectGroup
  }, /* @__PURE__ */React.createElement(NativeSelect, {
    "aria-label": monthLabel,
    className: classes.calendarSelect,
    size: selectSize,
    value: value.getMonth(),
    onMouseDown: function onMouseDown(event) {
      return preventFocus && event.preventDefault();
    },
    onChange: function onChange(event) {
      return _onChange(dayjs(value).set("month", parseInt(event.currentTarget.value, 10)).toDate());
    },
    data: getMonthsNames(locale).map(function (month, index) {
      return {
        label: upperFirst(month),
        value: index.toString()
      };
    })
  }), /* @__PURE__ */React.createElement(NativeSelect, {
    "aria-label": yearLabel,
    className: classes.calendarSelect,
    size: selectSize,
    value: value.getFullYear(),
    onMouseDown: function onMouseDown(event) {
      return preventFocus && event.preventDefault();
    },
    onChange: function onChange(event) {
      return _onChange(dayjs(value).set("year", parseInt(event.currentTarget.value, 10)).toDate());
    },
    data: getYearsRange(yearsRange).map(function (year) {
      return {
        label: year.toString(),
        value: year.toString()
      };
    })
  })) : /* @__PURE__ */React.createElement(Text, {
    className: classes.calendarLabel,
    size: size
  }, upperFirst(dayjs(value).locale(locale).format(labelFormat)));
}
CalendarLabel.displayName = "@mantine/dates/CalendarLabel";
export { CalendarLabel };